import React from 'react';

import { format, parseISO } from 'date-fns';

import { Species } from '../../api/fishrules/getSpeciesAtLocation';
import { Heading } from '../Heading/Heading';
import { Text } from '../Text/Text';

const getDateFormat = (date: string): string => format(parseISO(date), 'MMMM dd, yyyy');

const getSeasonState = (
  seasons: Species['seasons'],
): {
  seasonLabel: string;
  component: React.ReactElement;
} => {
  if (seasons.length) {
    const currentDate = new Date();
    const isClosedSeason = seasons.some(
      element =>
        parseISO(element.starts_at.date) <= currentDate &&
        currentDate <= parseISO(element.ends_at.date),
    );

    if (isClosedSeason) {
      return {
        seasonLabel: 'Closed',
        component: (
          <>
            <Heading variant="sm" className="mb-4">
              Closed season(s)
            </Heading>
            {seasons.map(item => (
              <div key={`closed-seasons-${item.id}`} className="py-4">
                <Text className="mb-0">From {getDateFormat(item.starts_at.date)}</Text>
                <Text className="mb-0">To {getDateFormat(item.ends_at.date)}</Text>
              </div>
            ))}
          </>
        ),
      };
    }
    return {
      seasonLabel: 'Open',
      component: (
        <>
          <Heading variant="sm" className="mb-4">
            Closed season(s)
          </Heading>
          {seasons.map(item => (
            <div key={`closed-seasons-${item.id}`} className="py-4">
              <Text className="mb-0">From {getDateFormat(item.starts_at.date)}</Text>
              <Text className="mb-0">To {getDateFormat(item.ends_at.date)}</Text>
            </div>
          ))}
        </>
      ),
    };
  }
  return {
    seasonLabel: 'Open',
    component: (
      <>
        <Heading variant="sm" className="mb-4">
          Open
        </Heading>
        <Text className="mb-0">
          Presently, there is no closed season for this species in these waters.
        </Text>
      </>
    ),
  };
};

export { getSeasonState };
